module.exports = __webpack_public_path__ + "static/media/stijnbessem-case-teatopics-intro-card1.1.984ebf83.jpg";